import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropdown", "customWrapper", "customField", "backButton"]

  connect() {
    if (!this.hasDropdownTarget || !this.hasCustomWrapperTarget || !this.hasCustomFieldTarget) return
    if (this.dropdownTarget.disabled) return

    this.toggle()
  }

  dropdownChanged() {
    this.toggle()
  }

  back(event) {
    event.preventDefault()

    this.customFieldTarget.value = ""
    this.dropdownTarget.selectedIndex = 0

    this.dropdownTarget.classList.remove("hidden")
    this.customWrapperTarget.classList.add("hidden")

    if (this.customFieldTarget.hasAttribute("required")) {
      this.customFieldTarget.removeAttribute("required")
      this.dropdownTarget.setAttribute("required", "required")
    }

    this.dropdownTarget.disabled = false
  }

  toggle() {
    const selectedValue = this.dropdownTarget.value
    const isOtherSelected = selectedValue && /others?\s*\(specify\)/i.test(selectedValue)

    if (isOtherSelected) {
      this.dropdownTarget.classList.add("hidden")
      this.customWrapperTarget.classList.remove("hidden")
      this.customFieldTarget.focus()

      if (this.dropdownTarget.hasAttribute("required")) {
        this.dropdownTarget.removeAttribute("required")
        this.customFieldTarget.setAttribute("required", "required")
      }
    } else {
      this.dropdownTarget.classList.remove("hidden")
      this.customWrapperTarget.classList.add("hidden")
      this.customFieldTarget.value = ""

      if (this.customFieldTarget.hasAttribute("required")) {
        this.customFieldTarget.removeAttribute("required")
        this.dropdownTarget.setAttribute("required", "required")
      }
    }
  }
}
